import type { Benefit, NavItem } from "@/types";

export const topBarMessages: string[] = [
  "Atendimento personalizado pelo WhatsApp",
  "Escolha seus favoritos e finalize com facilidade",
  "Calçados e acessórios para todos os seus momentos",
  "Entrega e retirada combinadas no atendimento",
];

export const mainNav: NavItem[] = [
  { label: "Novidades", href: "/novidades" },
  {
    label: "Sapatos",
    href: "/categoria/sandalias",
    children: [
      { label: "Sandálias", href: "/categoria/sandalias" },
      { label: "Scarpins", href: "/categoria/scarpins" },
      { label: "Sapatilhas", href: "/categoria/sapatilhas" },
      { label: "Mules", href: "/categoria/mules" },
      { label: "Mocassins", href: "/categoria/mocassins" },
      { label: "Tênis", href: "/categoria/tenis" },
      { label: "Rasteiras", href: "/categoria/rasteiras" },
      { label: "Papetes", href: "/categoria/papetes" },
      { label: "Botas", href: "/categoria/botas" },
    ],
  },
  { label: "Bolsas", href: "/categoria/bolsas" },
  {
    label: "Acessórios",
    href: "/categoria/cintos",
    children: [
      { label: "Cintos", href: "/categoria/cintos" },
      { label: "Semijoias", href: "/categoria/semijoias" },
    ],
  },
];

export const benefits: Benefit[] = [
  {
    id: "atendimento",
    icon: "ri-heart-3-line",
    title: "Atendimento próximo",
    description: "Cada dúvida é respondida com atenção e cuidado, do primeiro contato à entrega.",
  },
  {
    id: "whatsapp",
    icon: "ri-whatsapp-line",
    title: "Compra facilitada pelo WhatsApp",
    description: "Escolha seus favoritos com tranquilidade e finalize tudo em uma conversa simples.",
  },
  {
    id: "entrega",
    icon: "ri-truck-line",
    title: "Entrega e retirada combinadas",
    description: "Você escolhe o melhor jeito de receber, combinado direto no atendimento.",
  },
  {
    id: "numeracao",
    icon: "ri-ruler-2-line",
    title: "Ajuda para escolher modelo e numeração",
    description: "Contamos com você para acertar o modelo e a numeração certa desde a primeira vez.",
  },
];

export const footerCategories: NavItem[] = [
  { label: "Sandálias", href: "/categoria/sandalias" },
  { label: "Scarpins", href: "/categoria/scarpins" },
  { label: "Sapatilhas", href: "/categoria/sapatilhas" },
  { label: "Mules", href: "/categoria/mules" },
  { label: "Mocassins", href: "/categoria/mocassins" },
  { label: "Tênis", href: "/categoria/tenis" },
  { label: "Rasteiras", href: "/categoria/rasteiras" },
  { label: "Papetes", href: "/categoria/papetes" },
  { label: "Botas", href: "/categoria/botas" },
  { label: "Bolsas", href: "/categoria/bolsas" },
  { label: "Cintos", href: "/categoria/cintos" },
  { label: "Semijoias", href: "/categoria/semijoias" },
  { label: "Novidades", href: "/novidades" },
];

export const WHATSAPP_NUMBER = "5562998023960";
export const WHATSAPP_ORDER_BASE = `https://wa.me/${WHATSAPP_NUMBER}`;
export const WHATSAPP_URL = "https://wa.me/message/6X77HRWZGKPQH1";
export const INSTAGRAM_URL = "https://www.instagram.com/vellora__studio/";
export const VELLORA_URL = "https://vellorastudio.suapagina.net.br/";